export interface WicketApiFormError {
  status: number;
  type: string;
  details: string;
  errors: WicketApiFormFieldError[];
}

interface WicketApiFormFieldError {
  status: number;
  type: string;
  details: string;
  field?: string;
  error: WicketApiErrorCode;
}

type WicketApiErrorCode =
  | 'NOT_FOUND'
  | 'ALREADY_EXISTS'
  | 'VALIDATION_ERROR'
  | 'PATTERN_VALIDATION_ERROR';
